import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as focusTrap from 'focus-trap';
import MicroModal from 'micromodal'; 
import Rellax from 'rellax';

// Navbar
var body = document.querySelector('body');
var navbar = document.querySelector('.navbar');
var navbarLogo = document.querySelector('.navbar .logo');
var navbarCta = document.querySelector('.navbar #cta');
var navbarMenu = document.querySelector('.navbar #menu');
var navbarOffcanvas = document.querySelector('.navbar .offcanvas');
function toggleNavStyles() {
  navbarLogo.classList.toggle('primary');
  navbarLogo.classList.toggle('white');
  navbarCta.classList.toggle('dark');
  navbarCta.classList.toggle('light');
  navbarMenu.classList.toggle('dark');
  navbarMenu.classList.toggle('light');
}
var navbarTrap = focusTrap.createFocusTrap('.navbar', {
  onActivate: () => {
    body.classList.add('no-scroll');
    navbar.classList.add('open');
    navbarMenu.setAttribute('aria-expanded', true);
    navbarOffcanvas.hidden = false;
    toggleNavStyles();
  },
  onDeactivate: () => {
    body.classList.remove('no-scroll');
    navbar.classList.remove('open');
    navbarMenu.setAttribute('aria-expanded', false);
    navbarOffcanvas.hidden = true;
    toggleNavStyles();
  },
});

navbarMenu.addEventListener('click', function() {
  if (navbarOffcanvas.hidden) {
    navbarTrap.activate();
  } else {
    navbarTrap.deactivate();
  }
});

// Modals
MicroModal.init({
  openTrigger: 'data-modal-open',
  closeTrigger: 'data-modal-close',
  disableScroll: true
});

// Parallax
var rellax = new Rellax('.parallax', {
  speed: -2,
});

// Scroll animation
const scrollElements = document.querySelectorAll('.scroll-animate');
scrollElements.forEach((el) => {
  el.style.opacity = 0
  el.classList.add('animate');
})
const elementInView = (el) => {
  const elementTop = el.getBoundingClientRect().top;
  return ( elementTop <= 
    ((window.innerHeight || document.documentElement.clientHeight) - 10)
  );
};
const addAnimate = (el) => {
  el.classList.add('animate');
};
const removeAnimate = (el) => {
  el.classList.remove('animate');
};
window.addEventListener('scroll', () => {
  scrollElements.forEach((el) => {
    if (!elementInView(el)) {
      removeAnimate(el);
    } else {
      addAnimate(el);
    }
  })
})

// Remove Eventbrite styles
var eventDescription = document.querySelector('.event-description');
if (eventDescription) {
  var eventDescriptionDivs = eventDescription.getElementsByTagName('div');
  eventDescriptionDivs.forEach(div => {
    div.removeAttribute('style');
  });
}

// Sync 3rd party tracking codes to Hubspot banner settings
var _hsp = window._hsp = window._hsp || [];
_hsp.push(['addPrivacyConsentListener', function(consent) {
  // return if no changes
  if (JSON.stringify(consent.categories) === JSON.stringify(consent.previousCategories)) {
    return
  }
  // clear cookies except prefs
  var allCookies = document.cookie
    .replace(/__hs_cookie_cat_pref=.(.*?)(;|$)/, '').split(';')
  for (const cookie of allCookies) {
    var newCookie = cookie
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/')
    // add expired cookies covering domain variations
    document.cookie = newCookie
    document.cookie = newCookie + ';domain=' + location.host.replace(/:(.*)/, '')
    document.cookie = newCookie + ';domain=.' + location.host.replace(/:(.*)/, '')
    document.cookie = newCookie + ';domain=' + location.host.replace(/.+?(?=\.)/, '')
  }
  // set cookies scripts
  var cookie_categories = consent.categories
  for (const category in cookie_categories) {
    var scriptElement = document.querySelector(`[data-script="${category}"]`);
    if (cookie_categories[category] && cookie_content[category]) {
      if (!scriptElement) {
        var script = document.createElement('script')
        script.setAttribute('data-script', category)
        script.innerHTML = cookie_content[category]
        document.head.appendChild(script)
      }
    }
    if (!cookie_categories[category] && scriptElement) {
      scriptElement.remove()
    }
  }
}]);
